<template>
    <div class="loading-container" :style="'height:'+wheight+'px'">
        <div class="inner">
			<van-loading color="#1989fa" />
        </div>
    </div>
</template>

<script>
    export default {
        name: "loading",
        data() {
            return {
                wheight: document.documentElement.clientHeight
            }
        }
    }
</script>

<style lang="less" scoped>
    .loading-container {
        height: 100%;
        width: 100%;
        z-index: 999;
        display: flex;
        justify-content: center;
        align-items: center;
        position: fixed;
		top:0;
		left: 0;

        .inner {
            width: 100px;
            height: 100px;
			border-radius: 20%;
            display: flex;
            justify-content: center;
            align-items: center;
			background-color: rgba(0, 0, 0, 0);
        }
    }
</style>

